import type { SelectedFilters, TaskCenterContext, TaskMode } from './types';

export const TASK_ARCHIVED = 'TASK_ARCHIVED' as const;

// This type cast as const defines the source as a empty string literal type, it not specified it will throw an error
export const DEFAULT_FILTER_VALUES: SelectedFilters = {
  locations: [],
  source: '' as const,
  creator: null,
  sortType: null,
  showArchivedTab: false,
};

export const DEFAULT_CONTEXT_VALUE: TaskCenterContext = {
  taskMode: null,
  setTaskMode: (() => {}) as React.Dispatch<React.SetStateAction<TaskMode>>,
  isFromContactPanel: false,
  setIsFromContactPanel: (() => {}) as React.Dispatch<React.SetStateAction<boolean>>,
  locationIds: [],
  assignees: [],
  locationsData: [],
  selectedFilters: { ...DEFAULT_FILTER_VALUES },
  setFilters: () => {},
  selectedTask: null,
  setSelectedTask: () => {},
  selectedTab: '',
  setTab: () => {},
  taskId: null,
  setTaskId: () => {},
  setAssigneeFilter: () => {},
  assigneeFilter: '',
  isTaskCenterOpen: false,
  setIsTaskCenterOpen: () => {},
  resetFilters: () => {},
  onViewNotification: () => {},
  resetCreator: () => {},
  resetSelectedFilters: () => {},
  shouldGenerateAiTitle: false,
  isAIRCreatorEnabled: false,
  highlightedTaskId: null,
  setHighlightedTaskId: () => {},
  isTaskArchivalEnabled: false,
  setUserPreferenceShowArchivedTab: () => {},
};
